import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { format, isValid } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CompraDividaDTO } from '../../shared/dto/compraDividaDTO';
import BancoService from '../../services/bancoService';
import { Banco } from '../../shared/model/banco';

const bancoService = new BancoService();

const mascaraMoeda = (texto: string) => {
  const digitos = texto.replace(/\D/g, '');
  if (!digitos) return '';
  const comCentavos = digitos.padStart(3, '0');
  return `${parseInt(comCentavos.slice(0, -2), 10)},${comCentavos.slice(-2)}`;
};

const paraNumero = (texto: string) => parseFloat((texto || '0').replace(',', '.')) || 0;

const moeda = (valor: number) =>
  valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const downloadBase64 = (base64String: string, fileName: string): void => {
  const base64Data = base64String.split(',')[1] || base64String;
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

interface CompraDividaReemissaoProps {
  lista: CompraDividaDTO[];
  onChange: (lista: CompraDividaDTO[]) => void;
}

function CompraDividaReemissaoComponent({ lista, onChange }: CompraDividaReemissaoProps) {
  const [bancos, setBancos] = useState<Banco[]>([]);

  useEffect(() => {
    bancoService.listarTodosBancos()
      .then(resp => setBancos(resp.data))
      .catch(err => console.error('Erro ao carregar bancos:', err));
  }, []);

  const handleChangeSaldo = (texto: string, index: number) =>
    onChange(lista.map((item, i) => (i === index ? { ...item, saldoDevedor: mascaraMoeda(texto) } : item)));

  const totalCompra = lista.reduce((soma, item) => soma + paraNumero(item.saldoDevedor), 0);

  return (
    <div className="card" style={{ marginTop: '25px' }}>
      <div className="card-header"><strong>Saldo Devedor - Dados da Compra de Dívida</strong></div>
      <div className="card-body">
        {lista.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Banco/Entidade</th>
                  <th>Número Contrato</th>
                  <th style={{ width: '220px' }}>Saldo Devedor R$ (editável)</th>
                  <th>Vlr. Parcela</th>
                  <th>Vencimento</th>
                  <th>Arquivo</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((item, index) => (
                  <tr key={index}>
                    <td>{bancos.find(b => String(b.id) === String(item.bancoEntidade))?.nome || item.bancoEntidade}</td>
                    <td>{item.numeroContrato}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm text-end"
                        value={item.saldoDevedor}
                        onChange={(e) => handleChangeSaldo(e.target.value, index)}
                      />
                    </td>
                    <td>R$ {moeda(paraNumero(item.valorParcela))}</td>
                    <td>{item.dataVencimento instanceof Date && isValid(item.dataVencimento) ? format(item.dataVencimento, 'dd/MM/yyyy') : ''}</td>
                    <td>
                      <Button size="sm" disabled={!item.arquivo} onClick={() => downloadBase64(item.arquivo!, item.nomeArquivo!)}>
                        <FontAwesomeIcon icon={faDownload} />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-end"><strong>Valor compra de dívida: R$ {moeda(totalCompra)}</strong></div>
          </div>
        ) : (
          <span className="text-danger">Esta proposta não possui contratos de compra de dívida cadastrados.</span>
        )}
      </div>
    </div>
  );
}

export default CompraDividaReemissaoComponent;